import SingleParagraph, {
  SingleParagraphProps
} from '@/components/sections/single-paragraph'

export type BookPushProps = SingleParagraphProps

const BookPush = (props: BookPushProps) => {
  return <SingleParagraph align="center" {...props} />
}

export default BookPush
